<template>
    <article v-if="item !== null" class="branding-text" :class="getModuleThemeClass()">
        <h2 class="branding-text__headline">{{ item.Headline }}</h2>
        <h3 class="branding-text__second-headline">{{ item.SecondHeadline }}</h3>
        <div class="branding-text__content rich-text" v-html="item.RichText"></div>
        <template v-if="item.Link && item.Link.Link && item.Link.Link.Url">
            <link-component :link="item.Link"></link-component>
        </template>
    </article>
</template>
<script>
import LinkComponent from '../components/link-component.vue';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'BrandingText',
    components: {
        LinkComponent,
    },
    props: {
        item: {
            type: Object,
            default: null
        }
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        }
    }
};
</script>
